import { computed, Injectable, signal } from '@angular/core';

/**
 * Tracks in-flight HTTP requests for global loading UI (spinner, progress bar).
 * Pair with {@link loadingInterceptor} or call `beginRequest` / `endRequest` manually.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private nextRequestId = 0;
  private readonly activeRequestIds = new Set<number>();
  private readonly pending = signal(0);

  readonly pendingCount = this.pending.asReadonly();
  readonly isLoading = computed(() => this.pending() > 0);

  beginRequest(): number {
    const requestId = ++this.nextRequestId;
    this.activeRequestIds.add(requestId);
    this.pending.update((n) => n + 1);
    return requestId;
  }

  endRequest(requestId: number): void {
    if (!this.activeRequestIds.has(requestId)) {
      return;
    }
    this.activeRequestIds.delete(requestId);
    this.pending.update((n) => n - 1);
  }
}
